function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import ArticlesEditData from './ArticlesEditData.context';
import Button from '../../common/Button.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import ArticleProjectIconsAdd from './ArticleProjectIconsAdd.modal';
var ArticleProjectIcons = function ArticleProjectIcons(_ref) {
  var articlesAction = _ref.articlesAction,
    cmsProjectIcons = _ref.cmsProjectIcons,
    projectIconsAction = _ref.projectIconsAction,
    addModalAction = _ref.addModalAction;
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var articleID = state.articleID,
    articleType = state.articleType,
    projectIcons = state.projectIcons,
    archived = state.archived;
  useEffect(function () {
    projectIconsAction({});
  }, []);
  if (articleType !== 'project') return null;
  var projectIconsArr = (projectIcons === null || projectIcons === void 0 ? void 0 : projectIcons.map(function (x) {
    return x.iconID;
  })) || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Project Icons",
    button: {
      label: 'Add Icon',
      type: 'add',
      permission: 'edit-pos-articles',
      disabled: archived,
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(ArticleProjectIconsAdd, {
            articleID: articleID
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, projectIconsArr.map(function (x) {
    var _cmsProjectIcons$x, _cmsProjectIcons$x2;
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setSelected(x);
      },
      style: {
        cursor: 'pointer'
      }
      // className='project-icon'
      ,
      key: "icon".concat(x)
    }, /*#__PURE__*/React.createElement("img", {
      src: "".concat(bucket, "/").concat((_cmsProjectIcons$x = cmsProjectIcons[x]) === null || _cmsProjectIcons$x === void 0 ? void 0 : _cmsProjectIcons$x.filename),
      style: {
        height: 30
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        position: 'relative',
        top: -8,
        marginLeft: 10
      }
    }, (_cmsProjectIcons$x2 = cmsProjectIcons[x]) === null || _cmsProjectIcons$x2 === void 0 ? void 0 : _cmsProjectIcons$x2.title));
  }), selected && !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Cancel",
    type: "cancel",
    onClick: function onClick() {
      return setSelected(null);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      articlesAction({
        formData: {
          articleID: articleID,
          iconID: selected
        },
        method: 'delete',
        route: 'project-icons'
      });
      setSelected(null);
    }
  })))));
};
var mstp = function mstp(s) {
  return {
    cmsProjectIcons: s.cms.projectIcons
  };
};
var mdtp = {
  articlesAction: cmsActions.articles,
  addModalAction: modalActions.add,
  removeModalAction: modalActions.remove,
  projectIconsAction: cmsActions.projectIcons
};
export default connect(mstp, mdtp)(ArticleProjectIcons);